// ファイル名作成
export const extractFileName = (contentDisposition: any) => {
  let matches;
  let defaultFileName = "default.csv"; // デフォルトファイル名

  // `filename*` を優先的に解析
  matches = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
  if (matches && matches[1]) {
    return decodeURIComponent(matches[1]); // UTF-8 でデコード
  }

  // `filename` を解析
  matches = contentDisposition.match(/filename=([^;]+)/);
  if (matches && matches[1]) {
    return matches[1].replace(/["']/g, ""); // 不要なクォートを除去
  }

  // ファイル名が見つからない場合
  return defaultFileName;
};
